import { CARD_VARIANT, FOLDER_STATUS } from "@shared/components/card/types";
import FolderFileAddPlusIcon from "@svg/new-design/folder-file-add-plus";
import FolderFileCloseIcon from "@svg/new-design/folder-file-close";
import FolderFileTickIcon from "@svg/new-design/folder-file-tick";
import { STATUS } from "@types";

export const CardContainerImageClassName = {
  [CARD_VARIANT.GRID]: "w-full mb-1 sm:mb-2   ",
  [CARD_VARIANT.LIST]:
    "sm:w-2/5 listImage w-1/3 shrink-0  max-w-[320px]  h-max rounded-4 overflow-hidden",
  [CARD_VARIANT.HALF_LIST]: "w-56 ml-4     h-44 ",
  [CARD_VARIANT.CHECKBOX]: "sm:w-28 w-24 sm:ml-3  ml-2   ",
  [CARD_VARIANT.START_LEARNING]: "sm:w-44 w-28 sm:ml-3  ml-2  ",
};

export const explorePropsCard = {
  showBorder: true,
  showTime: true,
  showTeacher: true,
  showTag: false,
};

export const festivalPropsCard = {
  showTag: true,
  showShoppingCart: true,
  showTime: true,
  showTeacher: true,
};

export const PercentFestivalPropsCard = {
  showTag: true,
  showShoppingCart: true,
  showTime: true,
  showTeacher: true,
  showDetail: true,
};

export const homePropsCard = {
  showDetail: true,
  showTag: false,
  hugElement: false,
  showTime: true,
  showTeacher: true,
};

export const folderIcon = {
  [FOLDER_STATUS.MANAGE_FOLDER]: {
    icon: FolderFileAddPlusIcon,
    title: "افزودن به پوشه",
    class: "!text-fds-icon-primary",
  },
  [FOLDER_STATUS.FOLDER_SELECT]: {
    icon: FolderFileTickIcon,
    title: "حذف از پوشه",
    class: "!text-fds-icon-brand",
  },
  [FOLDER_STATUS.FOLDER_REMOVE]: {
    icon: FolderFileCloseIcon,
    title: "حذف از پوشه",
    class: "!text-fds-icon-danger",
  },
};

export const publishSorting = [
  STATUS.PLANNING,
  STATUS.START_RECORDING,
  STATUS.RECORDING,
  STATUS.EDITING,
  STATUS.QUALITY_INSPECTION,
  STATUS.PUBLISHING,
];
